import cn from 'classnames'
import s from './Checkbox.module.scss'

interface CheckboxProps {
    onChange?: () => void
    label?: React.ReactNode
    checked?: boolean
    name?: string
    id?: string
    className?: string
}

const Checkbox = ({
    onChange,
    label,
    checked,
    name,
    id,
    className
}: CheckboxProps): React.ReactElement => {
    return (
        <span className={s['container']}>
            <label className="mt-3" htmlFor={id}>
                <input
                    type="checkbox"
                    onChange={onChange}
                    checked={checked}
                    className={cn(className, 'form-checkbox h-6 w-6 text-p-2')}
                    name={name}
                    id={id}
                />
                {label && <span className="ml-2 text-p-2">{label}</span>}
            </label>
        </span>
    )
}

export default Checkbox
